'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialPinterestOutline = function IoSocialPinterestOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m10.6 28.1c2.8-2.8 4.4-6.6 4.4-10.6s-1.6-7.8-4.4-10.6-6.6-4.4-10.6-4.4-7.8 1.6-10.6 4.4-4.4 6.6-4.4 10.6 1.6 7.8 4.4 10.6c1.1 1.1 2.4 2 3.7 2.7 0.1-0.5 0.2-0.8 0.3-1.3 0.3-1.4 2.2-9.5 2.2-9.5s-0.6-1.2-0.6-2.8c0-2.6 1.6-4.5 3.4-4.5 1.6 0 2.4 1.2 2.4 2.6 0 1.6-1 4-1.6 6.2-0.5 1.9 1 3.3 2.8 3.3 3.2 0 5.5-4.2 5.5-9.3 0-3.8-2.6-6.6-7.3-6.6-5.3 0-8.6 3.9-8.6 8.4 0 1.5 0.5 2.5 1.2 3.4 0.3 0.4 0.4 0.5 0.2 0.9 0 0.4-0.3 1.1-0.3 1.4-0.2 0.5-0.5 0.7-0.9 0.5-2.4-1-3.6-3.7-3.6-6.7 0-5 4.2-10.9 12.5-10.9 6.7 0 11.1 4.9 11.1 10 0 6.9-3.8 12-9.5 12-1.8 0-3.6-1-4.3-2.2 0 0-0.9 4.1-1.1 4.8-0.2 0.5-0.3 1.1-0.6 1.5 1.2 0.3 2.4 0.5 3.7 0.5 4 0 7.8-1.6 10.6-4.4z' })
        )
    );
};

exports.default = IoSocialPinterestOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-pinterest-outline.js
// module id = 2943
// module chunks = 168707334958949